<div class="row justify-content-center">
  <div class="col-12 col-xxl-10">
    <div class="section-header mb-3 d-flex justify-content-between">
      <h1 class="h5 text-colonial mb-0">
        {{
        isClient || (isIntermediary && client)
        ? "Reembolsos"
        : "Seleccione el cliente"
        }}
      </h1>
      @if (client) {
      <app-client-button [client]="client" (clicked)="client = undefined"></app-client-button>
      }
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 col-xxl-10">
    <div class="card shadow-sm border-0 rounded-4 overflow-hidden">
      <div class="card-body p-0">
        <div class="d-flex justify-content-start mt-3 mb-3 ms-3">
          <div class="form-group" style="min-width: 300px">
            <label class="form-label" for="insuredSelect">Filtrar por asegurado</label>
            <select (ngModelChange)="onInsuredChange($event)" [(ngModel)]="selectedInsured" class="form-select"
              id="insuredSelect">
              <option [ngValue]="undefined">Todos los asegurados</option>
              @for (insured of insuredList; track $index) {
              <option [ngValue]="{
                  policyNumber: insured.policyNumber,
                  insured: insured.insured,
                  dependent: insured.dependent,
                }">
                {{ insured.name }}
                <span>({{ insured.relationship || "Titular" }})</span>
              </option>
              }
            </select>
          </div>
        </div>
        <shared-table-container>
          @if (isIntermediary && !client) {
          <app-client-selector (selectedClient)="handleSelectedClient($event)"></app-client-selector>
          } @else {
          <shared-table (actionButtonClicked)="addClaimRequests()" (paginateNext)="paginateNext()"
            (paginatePrev)="paginatePrev()" [headers]="tableHeaders" [items]="claimRequests" [pagination]="pagination"
            actionButtonTitle="Nuevo reembolso" searchPlaceholder="Buscar" (endSearching)="onEndSearching($event)"
            [(searchValue)]="searchValue" title="Reembolsos">
            <ng-template sharedTableColumn="claimDate" let-claimDate="claimDate">
              <span class="text-nowrap">{{
                claimDate | date: "dd/MM/yyyy"
                }}</span>
            </ng-template>
            <ng-template sharedTableColumn="claimsRequestId" let-claimsRequestId="claimsRequestId">
              <span class="text-nowrap d-block">
                {{ claimsRequestId?.toString().padStart(8, "0") }}
              </span>
            </ng-template>
            <ng-template sharedTableColumn="billedAmount" let-billedAmount="billedAmount">
              <span class="text-nowrap d-block">{{
                billedAmount
                | currency: "$" }}</span>
            </ng-template>
            <ng-template sharedTableColumn="paidAmount" let-paidAmount="paidAmount">
              <span class="paid-amount-cell d-block text-start">{{ paidAmount
                | currency: "$" }}</span>
            </ng-template>
            <ng-template sharedTableColumn="statusDescription" let-statusDescription="statusDescription">
              <div class="status-cell">
                <span class="badge" style="font-size: 11px;" [ngClass]="{
                    'bg-success':
                      statusDescription === 'Solicitado' || statusDescription === 'Autorizado',
                    'bg-warning text-dark': statusDescription === 'En Progreso',
                    'bg-danger': statusDescription === 'Rechazado',
                  }">
                  {{ statusDescription }}
                </span>
              </div>

            </ng-template>
          </shared-table>
          }
        </shared-table-container>
      </div>
    </div>
  </div>
</div>